module.exports = __webpack_public_path__ + "static/media/industrial.78c12eba.svg";